import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppFocusRestoreService {
  private readonly elementsByKey = new Map<string, HTMLElement>();
  // Фокусируемый элемент может быть уже отсоединён, когда механизм изоляции сессии спрашивает,
  // к какому target он относился, поэтому идентификатор должен существовать дольше, чем регистрация.
  private readonly keysByElement = new WeakMap<HTMLElement, string>();

  public register(key: string, element: HTMLElement): void {
    this.keysByElement.set(element, key);
    this.elementsByKey.set(key, element);
  }

  public unregister(key: string, element: HTMLElement): void {
    if (this.elementsByKey.get(key) === element) {
      this.elementsByKey.delete(key);
    }
  }

  public keyFor(node: Node): string | null {
    let current: Node | null = node;

    while (current) {
      if (current instanceof HTMLElement) {
        const key = this.keysByElement.get(current);
        if (key) {
          return key;
        }
      }

      current = current.parentElement;
    }

    return null;
  }

  public resolve(key: string): HTMLElement | null {
    const element = this.elementsByKey.get(key);

    return element?.isConnected ? element : null;
  }
}
